import {
  COMBINATION_RULE_CONDITION_TYPES,
  CombinationRuleConditionType,
} from "~/entity/CombinationRules";
import { FilterField } from "~/features/filter";
import type { FilterFieldOptionsHookResult } from "~/features/filter";
import { usePositionsSelectOptions } from "~/pages/Editor/EditorDirectories/EditorCombinationRules/model/usePositionsSelectOptions";

type Translate = (key: string) => string;

export const useMainPositionOptions = (): FilterFieldOptionsHookResult => {
  const { options, isLoading, searchOptions } = usePositionsSelectOptions();

  return {
    options: options.map(({ value, label }) => ({
      value: String(value),
      label,
    })),
    loading: isLoading,
    searchOptions,
  };
};

export const combinationRulesFilterFields = (t: Translate): FilterField[] => [
  {
    name: "mainPositionId",
    type: "select",
    label: t("combinationRules.positions_filter"),
    optionsHook: useMainPositionOptions,
  },
  {
    name: "createdBy",
    type: "input",
    label: t("combinationRules.author"),
  },
  {
    name: "createdAtFrom",
    nameTo: "createdAtTo",
    type: "dateRange",
    label: t("combinationRules.createdAt"),
    placeholder: t("combinationRules.date_begin"),
    placeholderTo: t("combinationRules.date_end"),
  },
  {
    name: "conditionTypes",
    type: "select",
    label: t("combinationRules.conditionType"),
    placeholder: t("combinationRules.all"),
    multiple: true,
    options: COMBINATION_RULE_CONDITION_TYPES.map(
      (value: CombinationRuleConditionType) => ({
        value,
        label: t(`combinationRules.conditionTypes.${value}`),
      }),
    ),
  },
  {
    name: "updatedBy",
    type: "input",
    label: t("combinationRules.updated_by_author"),
  },
  {
    name: "updatedAtFrom",
    nameTo: "updatedAtTo",
    type: "dateRange",
    label: t("combinationRules.updatedAt"),
    placeholder: t("combinationRules.date_begin"),
    placeholderTo: t("combinationRules.date_end"),
  },
];
